document.addEventListener('DOMContentLoaded', () => {
    let tp_claim_intimation_damage_assessor = document.querySelector('#cms_third_party_claim_intimation_damage_assessment_damage_assessor');

    if (tp_claim_intimation_damage_assessor !== null) {
        function hide_inputs(inputs) {
            inputs.forEach(function (e) {
                e.classList.add('hidden');
            });
        }

        function show_inputs(inputs) {
            inputs.forEach(function (e) {
                e.classList.remove('hidden');
            });
        }

        function dynamic_fields_handler(tp_claim_intimation_damage_assessor) {
            const estimation_inputs = document.querySelectorAll('.estimation_inputs');
            const repair_value_estimation_inputs = document.querySelectorAll('.repair_value_estimation_inputs');
            const market_value_estimation_inputs = document.querySelectorAll('.market_value_estimation_inputs');
            const amount_estimation_inputs = document.querySelectorAll('.amount_estimation_inputs');
            const tp_claim_intimation_da_labor_vatable_input = document.querySelector('#cms_third_party_claim_intimation_damage_assessment_labor_vatable');
            const tp_claim_intimation_da_spare_parts_vatable_input = document.querySelector('#cms_third_party_claim_intimation_damage_assessment_spare_parts_vatable');

            switch (tp_claim_intimation_damage_assessor.value) {
                case  'workshops_estimation':
                    show_inputs(estimation_inputs);
                    show_inputs(repair_value_estimation_inputs);
                    hide_inputs(amount_estimation_inputs);
                    hide_inputs(market_value_estimation_inputs);

                    tp_claim_intimation_da_labor_vatable_input.disabled = false
                    tp_claim_intimation_da_spare_parts_vatable_input.disabled = false

                    tp_claim_intimation_da_labor_vatable_input.checked = false
                    tp_claim_intimation_da_spare_parts_vatable_input.checked = true

                    break;

                case 'taqdeer_da':
                    show_inputs(estimation_inputs);
                    show_inputs(repair_value_estimation_inputs);
                    hide_inputs(amount_estimation_inputs);
                    hide_inputs(market_value_estimation_inputs);

                    tp_claim_intimation_da_labor_vatable_input.disabled = true
                    tp_claim_intimation_da_spare_parts_vatable_input.disabled = true

                    tp_claim_intimation_da_labor_vatable_input.checked = true
                    tp_claim_intimation_da_spare_parts_vatable_input.checked = true

                    break;

                case 'taqdeer_coa':
                case  'coa_estimation':
                    show_inputs(estimation_inputs);
                    show_inputs(market_value_estimation_inputs);
                    hide_inputs(amount_estimation_inputs);
                    hide_inputs(repair_value_estimation_inputs);
                    break;

                case 'property_estimation':
                case 'vehicle_repair_invoice':
                case 'property_repair_invoice':
                case 'medical_invoice':
                case 'court_verdict':
                    show_inputs(estimation_inputs);
                    show_inputs(amount_estimation_inputs);
                    hide_inputs(repair_value_estimation_inputs);
                    hide_inputs(market_value_estimation_inputs);
                    break;


                default:
                    hide_inputs(estimation_inputs);
                    hide_inputs(amount_estimation_inputs);
                    hide_inputs(market_value_estimation_inputs);
                    hide_inputs(repair_value_estimation_inputs);
                    break;
            }
        }

        function reset_fields() {
            document.querySelectorAll('input.subtotal, input.vat, input.total').forEach(function (e) {
                if (e.disabled)
                    e.value = '0.00';
            });
        }

        function recalculate_estimation(e) {
            let field_container, vatable_input, subtotal_input, vat_input, total_input, subtotal_amount, vat_amount,
                total_amount;

            field_container = e.closest('.columns');
            vatable_input = field_container.querySelector('.vatable');
            subtotal_input = field_container.querySelector('.subtotal');
            vat_input = field_container.querySelector('.vat');
            total_input = field_container.querySelector('.total');

            total_amount = parseFloat(total_input.value.replace(' ', ''));

            if (isNaN(total_amount)) {
                subtotal_input.value = '0.00';
                vat_input.value = '0.00';

            } else {
                vat_amount = vatable_input.checked ? total_amount * 15.0 / 115.0 : 0
                subtotal_amount = total_amount - vat_amount;
                subtotal_input.value = subtotal_amount.toFixed(2);
                vat_input.value = vat_amount.toFixed(2);
            }
        }

        function calculate_sums(container, selector) {
            let sum = 0;

            container.querySelectorAll(selector).forEach(function (e) {
                sum += parseFloat(e.value.replace(' ', ''));
            });

            return isNaN(sum) ? 0 : sum;
        }

        function calculate_diff(container, selector) {
            let sum = 0;

            container.querySelectorAll(selector).forEach(function (e) {
                if (sum === 0) {
                    sum = parseFloat(e.value.replace(' ', ''));
                } else {
                    sum -= parseFloat(e.value.replace(' ', ''));
                }
            });

            return isNaN(sum) ? 0 : sum;
        }

        function recalculate_totals(tp_claim_intimation_damage_assessor) {
            const tp_claim_intimation_damage_assessment_subtotal = document.querySelector('#cms_third_party_claim_intimation_damage_assessment_subtotal')
            const tp_claim_intimation_damage_assessment_vat = document.querySelector('#cms_third_party_claim_intimation_damage_assessment_vat')
            const tp_claim_intimation_damage_assessment_total = document.querySelector('#cms_third_party_claim_intimation_damage_assessment_total')

            const repair_value_estimation_inputs = document.querySelector('.repair_value_estimation_inputs');
            const market_value_estimation_inputs = document.querySelector('.market_value_estimation_inputs');
            const amount_estimation_inputs = document.querySelector('.amount_estimation_inputs');

            switch (tp_claim_intimation_damage_assessor.value) {
                case  'workshops_estimation':
                case 'taqdeer_da':
                    tp_claim_intimation_damage_assessment_subtotal.value = calculate_sums(repair_value_estimation_inputs, '.subtotal').toFixed(2);
                    tp_claim_intimation_damage_assessment_vat.value = calculate_sums(repair_value_estimation_inputs, '.vat').toFixed(2);
                    tp_claim_intimation_damage_assessment_total.value = calculate_sums(repair_value_estimation_inputs, '.total').toFixed(2);
                    break;

                case 'taqdeer_coa':
                case  'coa_estimation':
                    tp_claim_intimation_damage_assessment_subtotal.value = calculate_diff(market_value_estimation_inputs, '.subtotal').toFixed(2);
                    tp_claim_intimation_damage_assessment_vat.value = calculate_diff(market_value_estimation_inputs, '.vat').toFixed(2);
                    tp_claim_intimation_damage_assessment_total.value = calculate_diff(market_value_estimation_inputs, '.total').toFixed(2);
                    break;

                case 'property_estimation':
                case 'vehicle_repair_invoice':
                case 'property_repair_invoice':
                case 'medical_invoice':
                case 'court_verdict':
                    tp_claim_intimation_damage_assessment_subtotal.value = calculate_sums(amount_estimation_inputs, '.subtotal').toFixed(2);
                    tp_claim_intimation_damage_assessment_vat.value = calculate_sums(amount_estimation_inputs, '.vat').toFixed(2);
                    tp_claim_intimation_damage_assessment_total.value = calculate_sums(amount_estimation_inputs, '.total').toFixed(2);
                    break;

                default:
                    break;
            }
        }

        dynamic_fields_handler(tp_claim_intimation_damage_assessor);
        recalculate_totals(tp_claim_intimation_damage_assessor);

        tp_claim_intimation_damage_assessor.addEventListener("change", function () {
            dynamic_fields_handler(this);
            reset_fields();
            recalculate_totals(tp_claim_intimation_damage_assessor);
        });

        document.querySelectorAll('input.trigger_calculation').forEach(function (e) {
            e.addEventListener("change", function () {
                recalculate_estimation(e);
                recalculate_totals(tp_claim_intimation_damage_assessor);
            });
        });
    }
});
